import { render, staticRenderFns } from "./NewItemTds.vue?vue&type=template&id=6c147fb7&scoped=true&"
import script from "./NewItemTds.vue?vue&type=script&lang=js&"
export * from "./NewItemTds.vue?vue&type=script&lang=js&"
import style0 from "./NewItemTds.vue?vue&type=style&index=0&id=6c147fb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c147fb7",
  null
  
)

export default component.exports